import { INBOUND_STATUS, ORDER_APPROVAL_PHASE, TRANSFER_STATUS, } from "@erp/shared/types/order-approval-phase.types";
export const mockOrders = [
    {
        id: 1,
        createdTime: "2023-03-30T18:30:48.000Z",
        modifiedTime: "2025-08-17T21:32:51.000Z",
        creater: "119",
        modifier: "119",
        deletedYn: 0,
        approvalPhase: ORDER_APPROVAL_PHASE.발주작성,
        inboundPhase: INBOUND_STATUS.미입고,
        transferPhase: TRANSFER_STATUS.미송금,
        projectId: 3,
        projectCode: "프로젝트2",
        checkedDate: null,
        approvedDate: null,
        rejectedDate: null,
        rejectReason: null,
        dueDate: "2023-04-13T15:00:00.000Z",
        orderDate: "2023-04-02T18:30:48.000Z",
        companyName: "Company1",
        companyManager: "Manager1",
        companyRegistrationNumber: "REG0001",
        companyAddress: "Address 1",
        companyPhone: "010-1234-1001",
        companyFax: "02-5678-1001",
        paymentTerms: "선불",
        accountNumber: "100-200-301",
        orderConfirmationFile: "order_conf_1.pdf",
        businessRegistrationFile: "biz_reg_1.pdf",
        bankbookFile: "bankbook_1.pdf",
        firstBill: null,
        firstBillDate: null,
        secondBill: null,
        secondBillDate: null,
        thirdBill: null,
        thirdBillDate: null,
        firstConfirmTransfer: null,
        secondConfirmTransfer: null,
        thirdConfirmTransfer: null,
        createrName: "문병준",
        createrOfficePhoneNumber: "01012345678",
        createrPhoneNumber: "1234",
        checkerName: null,
        checkerId: null,
        approverName: null,
        approverId: null,
        rejecterName: null,
    },
    {
        id: 2,
        createdTime: "2023-03-30T18:30:48.000Z",
        modifiedTime: "2025-08-17T21:32:51.000Z",
        creater: "119",
        modifier: "119",
        deletedYn: 0,
        approvalPhase: ORDER_APPROVAL_PHASE.진행중,
        inboundPhase: INBOUND_STATUS.미입고,
        transferPhase: TRANSFER_STATUS.미송금,
        projectId: 3,
        projectCode: "프로젝트2",
        checkedDate: "2023-03-31T09:00:00.000Z",
        approvedDate: null,
        rejectedDate: null,
        rejectReason: null,
        dueDate: "2023-04-13T15:00:00.000Z",
        orderDate: "2023-04-03T18:30:48.000Z",
        companyName: "Company2",
        companyManager: "Manager2",
        companyRegistrationNumber: "REG0002",
        companyAddress: "Address 2",
        companyPhone: "010-1234-1002",
        companyFax: "02-5678-1002",
        paymentTerms: "선불",
        accountNumber: "100-200-302",
        orderConfirmationFile: "order_conf_2.pdf",
        businessRegistrationFile: "biz_reg_2.pdf",
        bankbookFile: "bankbook_2.pdf",
        firstBill: "bill1_2.pdf",
        firstBillDate: "2023-04-05T15:00:00.000Z",
        secondBill: null,
        secondBillDate: null,
        thirdBill: null,
        thirdBillDate: null,
        firstConfirmTransfer: null,
        secondConfirmTransfer: null,
        thirdConfirmTransfer: null,
        createrName: "문병준",
        createrOfficePhoneNumber: "01012345678",
        createrPhoneNumber: "1234",
        checkerName: "체커A",
        checkerId: 901,
        approverName: "엄현준",
        approverId: 120,
        rejecterName: null,
    },
    {
        id: 3,
        createdTime: "2023-03-30T18:30:48.000Z",
        modifiedTime: "2025-08-17T21:32:51.000Z",
        creater: "119",
        modifier: "119",
        deletedYn: 0,
        approvalPhase: ORDER_APPROVAL_PHASE.진행중,
        inboundPhase: INBOUND_STATUS.입고완료,
        transferPhase: TRANSFER_STATUS.미송금,
        projectId: 3,
        projectCode: "프로젝트2",
        checkedDate: "2023-04-01T09:00:00.000Z",
        approvedDate: null,
        rejectedDate: null,
        rejectReason: null,
        dueDate: "2023-04-13T15:00:00.000Z",
        orderDate: "2023-04-04T18:30:48.000Z",
        companyName: "Company3",
        companyManager: "Manager3",
        companyRegistrationNumber: "REG0003",
        companyAddress: "Address 3",
        companyPhone: "010-1234-1003",
        companyFax: "02-5678-1003",
        paymentTerms: "선불",
        accountNumber: "100-200-303",
        orderConfirmationFile: "order_conf_3.pdf",
        businessRegistrationFile: "biz_reg_3.pdf",
        bankbookFile: "bankbook_3.pdf",
        firstBill: "bill1_3.pdf",
        firstBillDate: "2023-04-06T15:00:00.000Z",
        secondBill: null,
        secondBillDate: null,
        thirdBill: null,
        thirdBillDate: null,
        firstConfirmTransfer: null,
        secondConfirmTransfer: null,
        thirdConfirmTransfer: null,
        createrName: "문병준",
        createrOfficePhoneNumber: "01012345678",
        createrPhoneNumber: "1234",
        checkerName: "체커B",
        checkerId: 902,
        approverName: "엄현준",
        approverId: 120,
        rejecterName: null,
    },
    {
        id: 4,
        createdTime: "2023-03-30T18:30:48.000Z",
        modifiedTime: "2025-08-17T21:32:51.000Z",
        creater: "119",
        modifier: "119",
        deletedYn: 0,
        approvalPhase: ORDER_APPROVAL_PHASE.진행중,
        inboundPhase: INBOUND_STATUS.미입고,
        transferPhase: TRANSFER_STATUS.송금완료,
        projectId: 3,
        projectCode: "프로젝트2",
        checkedDate: "2023-04-01T10:00:00.000Z",
        approvedDate: null,
        rejectedDate: null,
        rejectReason: null,
        dueDate: "2023-04-13T15:00:00.000Z",
        orderDate: "2023-04-05T18:30:48.000Z",
        companyName: "Company4",
        companyManager: "Manager4",
        companyRegistrationNumber: "REG0004",
        companyAddress: "Address 4",
        companyPhone: "010-1234-1004",
        companyFax: "02-5678-1004",
        paymentTerms: "선불",
        accountNumber: "100-200-304",
        orderConfirmationFile: "order_conf_4.pdf",
        businessRegistrationFile: "biz_reg_4.pdf",
        bankbookFile: "bankbook_4.pdf",
        firstBill: "bill1_4.pdf",
        firstBillDate: "2023-04-06T15:00:00.000Z",
        secondBill: "bill2_4.pdf",
        secondBillDate: "2023-04-09T15:00:00.000Z",
        thirdBill: null,
        thirdBillDate: null,
        firstConfirmTransfer: "transfer1_4.pdf",
        secondConfirmTransfer: null,
        thirdConfirmTransfer: null,
        createrName: "문병준",
        createrOfficePhoneNumber: "01012345678",
        createrPhoneNumber: "1234",
        checkerName: "체커C",
        checkerId: 903,
        approverName: "엄현준",
        approverId: 120,
        rejecterName: null,
    },
    {
        id: 5,
        createdTime: "2023-03-30T18:30:48.000Z",
        modifiedTime: "2025-08-17T21:32:51.000Z",
        creater: "119",
        modifier: "119",
        deletedYn: 0,
        approvalPhase: ORDER_APPROVAL_PHASE.진행중,
        inboundPhase: INBOUND_STATUS.입고완료,
        transferPhase: TRANSFER_STATUS.송금완료,
        projectId: 3,
        projectCode: "프로젝트2",
        checkedDate: "2023-04-01T11:00:00.000Z",
        approvedDate: null,
        rejectedDate: null,
        rejectReason: null,
        dueDate: "2023-04-13T15:00:00.000Z",
        orderDate: "2023-04-06T18:30:48.000Z",
        companyName: "Company5",
        companyManager: "Manager5",
        companyRegistrationNumber: "REG0005",
        companyAddress: "Address 5",
        companyPhone: "010-1234-1005",
        companyFax: "02-5678-1005",
        paymentTerms: "선불",
        accountNumber: "100-200-305",
        orderConfirmationFile: "order_conf_5.pdf",
        businessRegistrationFile: "biz_reg_5.pdf",
        bankbookFile: "bankbook_5.pdf",
        firstBill: "bill1_5.pdf",
        firstBillDate: "2023-04-06T15:00:00.000Z",
        secondBill: "bill2_5.pdf",
        secondBillDate: "2023-04-09T15:00:00.000Z",
        thirdBill: null,
        thirdBillDate: null,
        firstConfirmTransfer: "transfer1_5.pdf",
        secondConfirmTransfer: "transfer2_5.pdf",
        thirdConfirmTransfer: null,
        createrName: "문병준",
        createrOfficePhoneNumber: "01012345678",
        createrPhoneNumber: "1234",
        checkerName: "체커D",
        checkerId: 904,
        approverName: "엄현준",
        approverId: 120,
        rejecterName: null,
    },
    {
        id: 6,
        createdTime: "2023-03-30T18:30:48.000Z",
        modifiedTime: "2025-08-17T21:32:51.000Z",
        creater: "119",
        modifier: "119",
        deletedYn: 0,
        approvalPhase: ORDER_APPROVAL_PHASE.진행중,
        inboundPhase: INBOUND_STATUS.미입고,
        transferPhase: TRANSFER_STATUS.미송금,
        projectId: 3,
        projectCode: "프로젝트2",
        checkedDate: null,
        approvedDate: "2023-04-10T12:00:00.000Z",
        rejectedDate: null,
        rejectReason: null,
        dueDate: "2023-04-13T15:00:00.000Z",
        orderDate: "2023-04-07T18:30:48.000Z",
        companyName: "Company6",
        companyManager: "Manager6",
        companyRegistrationNumber: "REG0006",
        companyAddress: "Address 6",
        companyPhone: "010-1234-1006",
        companyFax: "02-5678-1006",
        paymentTerms: "선불",
        accountNumber: "100-200-306",
        orderConfirmationFile: "order_conf_6.pdf",
        businessRegistrationFile: "biz_reg_6.pdf",
        bankbookFile: "bankbook_6.pdf",
        firstBill: "bill1_6.pdf",
        firstBillDate: "2023-04-08T15:00:00.000Z",
        secondBill: null,
        secondBillDate: null,
        thirdBill: null,
        thirdBillDate: null,
        firstConfirmTransfer: null,
        secondConfirmTransfer: null,
        thirdConfirmTransfer: null,
        createrName: "문병준",
        createrOfficePhoneNumber: "01012345678",
        createrPhoneNumber: "1234",
        checkerName: "체커E",
        checkerId: 905,
        approverName: "엄현준",
        approverId: 120,
        rejecterName: null,
    },
    {
        id: 7,
        createdTime: "2023-03-30T18:30:48.000Z",
        modifiedTime: "2025-08-17T21:32:51.000Z",
        creater: "119",
        modifier: "119",
        deletedYn: 0,
        approvalPhase: ORDER_APPROVAL_PHASE.구매완료,
        inboundPhase: INBOUND_STATUS.입고완료,
        transferPhase: TRANSFER_STATUS.송금완료,
        projectId: 3,
        projectCode: "프로젝트2",
        checkedDate: null,
        approvedDate: "2023-04-11T12:00:00.000Z",
        rejectedDate: null,
        rejectReason: null,
        dueDate: "2023-04-13T15:00:00.000Z",
        orderDate: "2023-04-08T18:30:48.000Z",
        companyName: "Company7",
        companyManager: "Manager7",
        companyRegistrationNumber: "REG0007",
        companyAddress: "Address 7",
        companyPhone: "010-1234-1007",
        companyFax: "02-5678-1007",
        paymentTerms: "선불",
        accountNumber: "100-200-307",
        orderConfirmationFile: "order_conf_7.pdf",
        businessRegistrationFile: "biz_reg_7.pdf",
        bankbookFile: "bankbook_7.pdf",
        firstBill: "bill1_7.pdf",
        firstBillDate: "2023-04-09T15:00:00.000Z",
        secondBill: "bill2_7.pdf",
        secondBillDate: "2023-04-19T15:00:00.000Z",
        thirdBill: "bill3_7.pdf",
        thirdBillDate: "2023-04-29T15:00:00.000Z",
        firstConfirmTransfer: "transfer1_7.pdf",
        secondConfirmTransfer: "transfer2_7.pdf",
        thirdConfirmTransfer: "transfer3_7.pdf",
        createrName: "문병준",
        createrOfficePhoneNumber: "01012345678",
        createrPhoneNumber: "1234",
        checkerName: null,
        checkerId: null,
        approverName: "엄현준",
        approverId: 120,
        rejecterName: null,
    },
    {
        id: 8,
        createdTime: "2023-03-30T18:30:48.000Z",
        modifiedTime: "2025-08-17T21:32:51.000Z",
        creater: "119",
        modifier: "119",
        deletedYn: 0,
        approvalPhase: ORDER_APPROVAL_PHASE.구매완료,
        inboundPhase: INBOUND_STATUS.입고완료,
        transferPhase: TRANSFER_STATUS.송금완료,
        projectId: 3,
        projectCode: "프로젝트2",
        checkedDate: "2023-04-10T15:00:00.000Z",
        approvedDate: "2023-04-12T12:00:00.000Z",
        rejectedDate: null,
        rejectReason: null,
        dueDate: "2023-04-13T15:00:00.000Z",
        orderDate: "2023-04-09T18:30:48.000Z",
        companyName: "Company8",
        companyManager: "Manager8",
        companyRegistrationNumber: "REG0008",
        companyAddress: "Address 8",
        companyPhone: "010-1234-1008",
        companyFax: "02-5678-1008",
        paymentTerms: "선불",
        accountNumber: "100-200-308",
        orderConfirmationFile: "order_conf_8.pdf",
        businessRegistrationFile: "biz_reg_8.pdf",
        bankbookFile: "bankbook_8.pdf",
        firstBill: "bill1_8.pdf",
        firstBillDate: "2023-04-09T15:00:00.000Z",
        secondBill: "bill2_8.pdf",
        secondBillDate: "2023-04-19T15:00:00.000Z",
        thirdBill: null,
        thirdBillDate: null,
        firstConfirmTransfer: "transfer1_8.pdf",
        secondConfirmTransfer: "transfer2_8.pdf",
        thirdConfirmTransfer: null,
        createrName: "문병준",
        createrOfficePhoneNumber: "01012345678",
        createrPhoneNumber: "1234",
        checkerName: "체커F",
        checkerId: 906,
        approverName: "엄현준",
        approverId: 120,
        rejecterName: null,
    },
    {
        id: 9,
        createdTime: "2023-03-30T18:30:48.000Z",
        modifiedTime: "2025-08-17T21:32:51.000Z",
        creater: "119",
        modifier: "119",
        deletedYn: 0,
        approvalPhase: ORDER_APPROVAL_PHASE.반려,
        inboundPhase: INBOUND_STATUS.미입고,
        transferPhase: TRANSFER_STATUS.미송금,
        projectId: 3,
        projectCode: "프로젝트2",
        checkedDate: null,
        approvedDate: null,
        rejectedDate: "2023-04-10T12:00:00.000Z",
        rejectReason: "계약 조건 불일치",
        dueDate: "2023-04-13T15:00:00.000Z",
        orderDate: "2023-04-10T18:30:48.000Z",
        companyName: "Company9",
        companyManager: "Manager9",
        companyRegistrationNumber: "REG0009",
        companyAddress: "Address 9",
        companyPhone: "010-1234-1009",
        companyFax: "02-5678-1009",
        paymentTerms: "선불",
        accountNumber: "100-200-309",
        orderConfirmationFile: "order_conf_9.pdf",
        businessRegistrationFile: "biz_reg_9.pdf",
        bankbookFile: "bankbook_9.pdf",
        firstBill: "bill1_9.pdf",
        firstBillDate: "2023-04-09T15:00:00.000Z",
        secondBill: "bill2_9.pdf",
        secondBillDate: "2023-04-19T15:00:00.000Z",
        thirdBill: null,
        thirdBillDate: null,
        firstConfirmTransfer: null,
        secondConfirmTransfer: null,
        thirdConfirmTransfer: null,
        createrName: "문병준",
        createrOfficePhoneNumber: "01012345678",
        createrPhoneNumber: "1234",
        checkerName: null,
        checkerId: null,
        approverName: "엄현준",
        approverId: 120,
        rejecterName: null,
    },
];
export const mockOrderProducts = [
    {
        createdTime: "2025-07-10T06:59:08.000Z",
        modifiedTime: "2025-07-10T06:59:08.000Z",
        creater: "홍길동",
        modifier: "홍길동",
        deletedYn: 0,
        id: 1,
        orderId: 3,
        calcJson: "",
    },
    {
        createdTime: "2025-07-10T06:59:08.000Z",
        modifiedTime: "2025-07-10T06:59:08.000Z",
        creater: "홍길동",
        modifier: "홍길동",
        deletedYn: 0,
        id: 2,
        orderId: 3,
        calcJson: "",
    },
    {
        createdTime: "2025-07-10T06:59:08.000Z",
        modifiedTime: "2025-07-10T06:59:08.000Z",
        creater: "홍길동",
        modifier: "홍길동",
        deletedYn: 0,
        id: 3,
        orderId: 3,
        calcJson: "",
    },
    {
        createdTime: "2025-08-05T07:29:41.000Z",
        modifiedTime: "2025-08-05T07:29:41.000Z",
        creater: "119",
        modifier: "119",
        deletedYn: 0,
        id: 4,
        orderId: 6,
        calcJson: '{"cost_list":"발테","cost_list_colspan":4,"cost_unit":"식","cost_num":0,"cost_unit_price":0,"cost_total":3,"belong_data":[]}',
    },
    {
        createdTime: "2025-08-05T07:33:54.000Z",
        modifiedTime: "2025-08-05T07:33:54.000Z",
        creater: "119",
        modifier: "119",
        deletedYn: 0,
        id: 5,
        orderId: 7,
        calcJson: null,
    },
];
